/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergencySafeguardDelete
 */
export interface EmergencySafeguardDelete {
    /**
     * 
     * @type {string}
     * @memberof EmergencySafeguardDelete
     */
    emergency_id: string;
}

/**
 * Check if a given object implements the EmergencySafeguardDelete interface.
 */
export function instanceOfEmergencySafeguardDelete(value: object): value is EmergencySafeguardDelete {
    if (!('emergency_id' in value) || value['emergency_id'] === undefined) return false;
    return true;
}

export function EmergencySafeguardDeleteFromJSON(json: any): EmergencySafeguardDelete {
    return EmergencySafeguardDeleteFromJSONTyped(json, false);
}

export function EmergencySafeguardDeleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencySafeguardDelete {
    if (json == null) {
        return json;
    }
    return {
        
        'emergency_id': json['emergency_id'],
    };
}

export function EmergencySafeguardDeleteToJSON(json: any): EmergencySafeguardDelete {
    return EmergencySafeguardDeleteToJSONTyped(json, false);
}

export function EmergencySafeguardDeleteToJSONTyped(value?: EmergencySafeguardDelete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emergency_id': value['emergency_id'],
    };
}

